const HourGlassIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M3.33594 1.69531H12.6659"
        stroke="#F98600"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33594 14.3203H12.6659"
        stroke="#F98600"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00095 10.4733L9.64742 12.1196H11.5683V11.5708C11.5683 10.6248 11.1925 9.71755 10.5234 9.04863C9.85444 8.3797 8.94707 8.00391 8.00095 8.00391C7.05483 8.00391 6.14746 8.3797 5.47845 9.04863C4.80944 9.71755 4.43359 10.6248 4.43359 11.5708V12.1196H6.35448L8.00095 10.4733Z"
        fill="white"
      />
      <path
        d="M9.64742 12.1189L8.00095 10.4727L6.35448 12.1189H4.43359V14.3139H11.5683V12.1189H9.64742Z"
        fill="#F98600"
      />
      <path
        d="M9.64742 12.1189L8.00095 10.4727L6.35448 12.1189H4.43359V14.3139H11.5683V12.1189H9.64742Z"
        stroke="#F98600"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5683 4.43908V1.69531H4.43359V4.43908C4.43317 5.23518 4.7005 6.00828 5.19262 6.6341H10.8087C11.301 6.00833 11.5685 5.23523 11.5683 4.43908Z"
        fill="white"
      />
      <path
        d="M11.5683 4.43908V1.69531H4.43359V4.43908C4.43317 5.23518 4.7005 6.00828 5.19262 6.6341H10.8087C11.301 6.00833 11.5685 5.23523 11.5683 4.43908V4.43908Z"
        stroke="#F98600"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.19141 6.63281C5.52426 7.05999 5.9502 7.4056 6.43682 7.64332C6.92343 7.88104 7.45788 8.0046 7.99946 8.0046C8.54105 8.0046 9.0755 7.88104 9.56211 7.64332C10.0487 7.4056 10.4747 7.05999 10.8075 6.63281H5.19141Z"
        fill="white"
      />
      <path
        d="M5.19141 6.63281C5.52426 7.05999 5.9502 7.4056 6.43682 7.64332C6.92343 7.88104 7.45788 8.0046 7.99946 8.0046C8.54105 8.0046 9.0755 7.88104 9.56211 7.64332C10.0487 7.4056 10.4747 7.05999 10.8075 6.63281H5.19141Z"
        fill="#F98600"
        stroke="#F98600"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00095 10.4733L9.64742 12.1196H11.5683V11.5708C11.5683 10.6248 11.1925 9.71755 10.5234 9.04863C9.85444 8.3797 8.94707 8.00391 8.00095 8.00391C7.05483 8.00391 6.14746 8.3797 5.47845 9.04863C4.80944 9.71755 4.43359 10.6248 4.43359 11.5708V12.1196H6.35448L8.00095 10.4733Z"
        stroke="#F98600"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HourGlassIcon;
